import { useState, useEffect } from 'react';

import { useWindowSize } from './useSizeHook';

export const useResize = () => {
  const [goodsPerPage, setGoodsPerPage] = useState(4);
  const size = useWindowSize();

  useEffect(() => {
    if (size.width >= 1400) {
      setGoodsPerPage(4);
    } else if (size.width < 1400 && size.width > 1100) {
      setGoodsPerPage(3);
    } else if (size.width < 1100 && size.width > 700) {
      setGoodsPerPage(2);
    } else {
      setGoodsPerPage(1);
    }
  }, [size.width]);
  return goodsPerPage;
};
